import { OverlayContainer } from './styled';
import { LoadingWarren } from '@simplywallst/ui-core';

export const GeneratingReport = () => {
  return (
    <OverlayContainer data-cy-id="generating-report-overlay">
      <LoadingWarren />
      <p>
        Generating your report.
        <br />
        We recommend using Google Chrome for best results.
      </p>
    </OverlayContainer>
  );
};
